export default "__VITE_ASSET__88f21eca__"